import React from "react";

function Infrastructure() {
  return <div>Infrastructure</div>;
}

export default Infrastructure;
